export default "__VITE_ASSET__BGgPDreB__"